import { gql } from '@apollo/client';

const GET_DEFENDANTS_PAGED = gql`
    query defendantsPaged($first: Int, $after: String) {
        defendantsPaged(first: $first, after: $after) {
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    id
                    arrestDate
                    courtCase {
                        id
                        docket
                    }
                    firstName
                    lastName
                    birthdate
                    sex
                    streetAddress
                    addressAdministrativeLevel2 {
                        id
                        name
                    }
                    addressAdministrativeLevel1 {
                        id
                        name
                    }
                    addressRegion {
                        id
                        name
                    }
                    addressCountry {
                        id
                        name
                    }
                    nationality {
                        id
                        name
                    }
                    bailEvents {
                        id
                        date
                        bailGranted
                        bondAmount
                    }
                    charges {
                        verdict
                    }
                    pleaBargain
                    outcomeDate
                    outcome
                    sentenceDate
                    fine
                    fineCurrency
                    custodialMonths
                    suspendedFine
                    suspendedMonths
                    outcomeFactors {
                        impact
                        factor
                    }
                }
            }
        }
    }
`;

export default GET_DEFENDANTS_PAGED;
